/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState } from 'react';
import { Row, Col, Card, Spinner } from 'react-bootstrap';

import {
  HeroButtons,
  IHeroButtonProps,
  HeroContent,
  IHeroContentProps,
  HeroDescription,
  IHeroDescriptionProps,
  HeroImage,
  IHeroImageProps,
  HeroList,
  IHeroListProps,
  StatusComp,
  IStatusCompProps,
  CarouselSection,
  ICarouselSectionProps,
  PdfViewerModal,
  IPdfViewerModalProps,
  ImageModal,
  IImageModalProps,
  VideoViewerModal,
  IVideoViewerModalProps,
  AccordionComp,
  IAccordionProps,
  FooterComp,
  IFooterCompProps,
  BadgeCarousel,
  IBadgeCarouselProps,
  IBadgeCarouselItem,
  IFooterProps,
  Footer,
  BackArrowComp,
  MapModal,
  IMapModalProps,
  QRModal,
  IQRModalProps,
} from './components';
import { MyRow } from './styles';
import { StatusCompp } from './components/StatusComp2';

export type onBadgeCarouselItemClickProps = {
  onBadgeCarouselItemClick?(item: IBadgeCarouselItem): void;
};

export type IItemSpecMercuryProps = IHeroImageProps &
  IHeroContentProps &
  IHeroListProps &
  IHeroButtonProps &
  IHeroDescriptionProps &
  IStatusCompProps &
  ICarouselSectionProps &
  IVideoViewerModalProps &
  IImageModalProps &
  IPdfViewerModalProps &
  IAccordionProps &
  IFooterCompProps &
  IBadgeCarouselProps &
  onBadgeCarouselItemClickProps &
  IFooterProps & { backArrow?: boolean };
//   IAccordionProps &
//   IPdfViewerModalProps &
//   IImageModalProps &
//   ;

export interface IItemSpecMercuryWidgetProps {
  items: IItemSpecMercuryProps;
}

export const ItemSpecMercuryWidget = (props: IItemSpecMercuryProps) => {
  const {
    heroImage,
    title,
    subtitle,
    listItems,
    buttons,
    statusComp,
    carouselItems,
    carouselStyles,
    accordionItems,
    heroTitle,
    heroDescription,
    footerItems,
    badgeCarouselItems,
    onBadgeCarouselItemClick,
    backArrow,
    showcomment,
    setShowComment
  } = props;

  const [imageModalObj, setImageModalObj] = useState<{
    enableVisibility: boolean;
    src: string | undefined;
    title: string | undefined;
  }>({
    enableVisibility: false,
    src: undefined,
    title: undefined,
  });
  const [pdfModalObj, setPdfModalObj] = useState<{
    enableVisibility: boolean;
    src: string | undefined;
    title: string | undefined;
  }>({
    enableVisibility: false,
    src: undefined,
    title: undefined,
  });

  const [videoModalObj, setVideoModalObj] = useState<{
    enableVisibility: boolean;
    src: string | undefined;
    title: string | undefined;
  }>({
    enableVisibility: false,
    src: undefined,
    title: undefined,
  });

  const [mapModalObj, setMapModalObj] = useState<{
    enableVisibility: boolean;
    accessToken: string | undefined;
    markers: any | undefined;
    center: any | undefined;
  }>({
    enableVisibility: false,
    accessToken: undefined,
    markers: undefined,
    center: undefined,
  });

  const [QRModalObj, setQRModalObj] = useState<{
    enableVisibility: boolean;
    qrValue: string | undefined;
    title: string | undefined;
  }>({
    enableVisibility: false,
    qrValue: undefined,
    title: undefined,
  });

  const _onBadgeCarouselClick = (item: IBadgeCarouselProps) => {
    if (onBadgeCarouselItemClick) {
      onBadgeCarouselItemClick(item);
    }
  };

  const _onCarouselImageClick = async (item: ICarouselItem) => {
    if ((item?.type === 'img' || item?.type?.includes('image')) && item?.src) {
      setImageModalObj({
        ...imageModalObj,
        src: item.src,
        title: item.title,
        enableVisibility: true,
      });
    }
    if ((item?.type === 'pdf' || item?.type?.includes('pdf')) && item?.src) {
      // await WebBrowser.openBrowserAsync(item.src);
      setPdfModalObj({
        ...pdfModalObj,
        src: item?.src,
        title: item.title,
        enableVisibility: true,
      });
    }
    if (
      (item?.type === 'video' || item?.type?.includes('video')) &&
      item?.src
    ) {
      setVideoModalObj({
        ...videoModalObj,
        src: item.src,
        title: item.title,
        enableVisibility: true,
      });
    }
    if (item?.type === 'map' && item?.markers && item?.accessToken) {
      setMapModalObj({
        ...mapModalObj,
        accessToken: item.accessToken,
        markers: item.markers,
        center: item.center,
        enableVisibility: true,
      });
    }

    if (item?.type === 'qr') {
      setQRModalObj({
        ...QRModalObj,
        enableVisibility: true,
        qrValue: item?.src,
      });
    }
  };
  const _onDeny = () => {
    setImageModalObj({
      ...imageModalObj,
      src: undefined,
      title: undefined,
      enableVisibility: false,
    });
  };

  const onVideoClose = () => {
    setVideoModalObj({
      ...videoModalObj,
      src: undefined,
      title: undefined,
      enableVisibility: false,
    });
  };

  const onMapClose = () => {
    setMapModalObj({
      ...mapModalObj,
      accessToken: undefined,
      markers: undefined,
      center: undefined,
      enableVisibility: false,
    });
  };

  const onPdfClose = () => {
    setPdfModalObj({
      ...pdfModalObj,
      src: undefined,
      title: undefined,
      enableVisibility: false,
    });
  };

  const onQrClose = () => {
    setQRModalObj({
      ...QRModalObj,
      enableVisibility: false,
      qrValue: undefined,
    });
  };

  const _renderHeroImage = () => {
    if (heroImage?.image || heroImage?.title) {
      return <HeroImage {...props} />;
    }
  };
  const _renderHeroContent = () => {
    return (
      <Col xs={12} lg={10} className="justify-content-center text-align-center">
        <div className="d-flex">
          <div>
            {(heroImage?.image || heroImage?.title) && <HeroImage {...props} />}
          </div>
          {props?.StatusCompp ? (
            <div>
              <div className="d-flex">
                {(title || subtitle) && <HeroContent {...props} />}
                {statusComp && <StatusComp {...(props || {})} />}
              </div>
              {
                <div>
                  <StatusCompp {...(props || {})} showcomment={showcomment} setShowComment={setShowComment} closecomment={setShowComment} />
                </div>
              }
            </div>
          ) : (
            <>
              {(title || subtitle) && <HeroContent {...props} />}
              {statusComp && <StatusComp {...(props || {})} />}
            </>
          )}
        </div>

        {listItems && (
          <div style={{ paddingLeft: '5%' }}>
            <HeroList {...props} />
          </div>
        )}
        {buttons && <HeroButtons {...props} />}
      </Col>
    );
  };

  const _renderDescription = () => {
    if (heroTitle || heroDescription) {
      return <HeroDescription {...props} />;
    }
  };

  const _renderHeroSection = () => {
    return (
      <MyRow
        className={
          heroImage?.align === 'center'
            ? 'justify-content space-around align-items-center'
            : 'justify-content space-around'
        }
      >
        {/* {_renderHeroImage()} */}
        {_renderHeroContent()}
      </MyRow>
    );
  };

  const _renderCarousel = () => {
    if (Array.isArray(carouselItems) && carouselItems?.length > 0) {
      return (
        <>
          <hr className="mt-4" />
          <CarouselSection
            onCarouselImageClick={_onCarouselImageClick}
            carouselItems={carouselItems}
            carouselStyles={carouselStyles}
          />
        </>
      );
    } else if (Array.isArray(carouselItems) && carouselItems?.length === 0) {
      return (
        <div style={{ display: 'block' }} className={'m-5 p-5'}>
          <Spinner animation="border" variant="primary" size="lg" />
        </div>
      );
    }
  };

  const _renderBadgeCarousel = () => {
    if (Array.isArray(badgeCarouselItems) && badgeCarouselItems?.length > 0) {
      return (
        <>
          <hr className="mt-4" />
          <BadgeCarousel
            onCarouselImageClick={_onBadgeCarouselClick}
            carouselItems={badgeCarouselItems}
            carouselStyles={carouselStyles}
          />
        </>
      );
    }
  };

  const _renderBackArrow = () => {
    if (backArrow) {
      return <BackArrowComp />;
    }
  };

  const _renderAccordion = () => {
    if (Array.isArray(accordionItems)) {
      return <AccordionComp {...props} />;
    }
  };

  const _renderFooter = () => {
    return (
      <>
        <hr className="mt-4" />
        <Footer {...props} />
      </>
    );
    // if(Array.isArray(footerItems)){
    //     return (
    //         <>
    //         <hr className="mt-4" />
    //         <FooterComp {...props} />
    //           </>
    //     );
    // }
  };
  return (
    <>
      {!accordionItems && !carouselItems ? _renderHeroSection() : null}
      <Card>
        {_renderBackArrow()}
        {accordionItems || carouselItems ? _renderHeroSection() : null}
        {carouselItems &&
          Array.isArray(carouselItems) &&
          carouselItems.length > 0 &&
          _renderCarousel()}
        {_renderBadgeCarousel()}
        {_renderDescription()}
        {_renderAccordion()}
        {/* {_renderFooter()} */}
        <PdfViewerModal
          {...(props || {})}
          showModal={pdfModalObj?.enableVisibility}
          title={pdfModalObj?.title}
          file={pdfModalObj?.src}
          onPdfClose={onPdfClose}
        />
        <VideoViewerModal
          {...(props || {})}
          videoSrc={videoModalObj?.src}
          showModal={videoModalObj?.enableVisibility}
          title={videoModalObj?.title}
          file={videoModalObj?.src}
          closeModal={onVideoClose}
        />
        <ImageModal
          {...(props || {})}
          showModal={imageModalObj?.enableVisibility}
          title={imageModalObj?.title}
          imageSrc={imageModalObj?.src}
          onDeny={_onDeny}
        />
        <MapModal
          {...(props || {})}
          showModal={mapModalObj?.enableVisibility}
          closeModal={onMapClose}
          markers={mapModalObj?.markers}
          center={mapModalObj?.center}
          accessToken={mapModalObj?.accessToken}
        />
        <QRModal
          {...(props || {})}
          showModal={QRModalObj?.enableVisibility}
          closeModal={onQrClose}
          qrValue={QRModalObj?.qrValue}
        />
      </Card>
    </>
  );
};

ItemSpecMercuryWidget.defaultProps = {
  backArrow: false,
};
